import { render, staticRenderFns } from "./create_buisness.vue?vue&type=template&id=7b1b407b&scoped=true&"
import script from "./create_buisness.vue?vue&type=script&lang=js&"
export * from "./create_buisness.vue?vue&type=script&lang=js&"
import style0 from "./create_buisness.vue?vue&type=style&index=0&id=7b1b407b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1b407b",
  null
  
)

export default component.exports